"use strict";

const cartLists = {
    cartItems: {},
    sections: {},
    SHOPIFY_CART: {},

    cartTotals: '.cart-info-container',

    event: {
        type: "click",
        bindableWrappers: [".product__mini__size__wrapper", ".product__free__gift__wrapper"],
        bindableElement: ".product__upsell__item"
    },

    init: function () {
        this.destroy                = this.destroy.bind(this);
        this.show                   = this.show.bind(this);
        this.manageCartData         = this.manageCartData.bind(this);
        this.addUpsellToCart        = this.addUpsellToCart.bind(this);
        this.removeUpsellFromCart   = this.removeUpsellFromCart.bind(this);
        this.updateCartTotals       = this.updateCartTotals.bind(this);
        
        this.collectData();
    },

    /**
     * all SWAL2 messages
     */
    swalMessages: {
        
        /**
         * Add message on product add to Cart
         * 
         * @param {string} productName 
         */
        addItem: function (productName) {
            if (typeof Swal === 'function') {
                Swal.fire({
                    position: 'top-end',
                    type: 'success',
                    customClass: {
                      icon: 'swal2-add',
                      cancelButton: 'custom-swal-toast-btn-close anim',
                      container: 'custom-swal-toast-container',                      
                      content: 'custom-swal-toast-content'
                    },
                    html: '<div style="padding: 0 10px">The product ' + productName + ' has been added to your cart.</div>',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none"   fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg>',
                    toast: true,
                    timer: 5000
                });
            }
        },
        
        /**
         * Add message on product remove from Cart
         * 
         * @param {string} productName 
         * @param {boolean} multiple 
         */
        removeItem: function (productName, multiple) {
            if (typeof Swal === 'function') {
                let preMessage = 'The product ',
                    postMessage = ' has been removed from your cart.';
                
                if (multiple) {
                    preMessage = 'The products ',
                    postMessage = ' has been removed from your cart.';
                }

                Swal.fire({
                    position: 'top-end',
                    type: 'error',
                    customClass: {
                      icon: 'swal2-remove',
                      cancelButton: 'custom-swal-toast-btn-close anim',
                      container: 'custom-swal-toast-container',
                      content: 'custom-swal-toast-content'
                    },
                    iconHtml: '-',
                    html: '<div style="padding: 0 10px">'+ preMessage + productName + postMessage +'</div>',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none"   fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg>',
                    toast: true,
                    timer: 5000
                });
            }
        },
        
        /**
         * Add message on error
         * 
         */
        errorItem: function () {
            if (typeof Swal === 'function') {
                Swal.fire({
                    type: 'error',
                    html: 'You have reached the limit of product&#39;s type',
                    showConfirmButton: true,
                    timer: 2500
                });
            }
        }
    },

    collectData: function () {
        this.sections = window.sectionsHandler;
        this.getCartData(this.manageCartData);
    },

    manageCartData: function () {
        let counter = 0,
            index   = 0,
            errors   = {},
            dataPop = [],
            sectPop = {};

        if (this.SHOPIFY_CART.hasOwnProperty('items')) {
            const   self = this,
                    maxCounter = this.SHOPIFY_CART.items.length;

            for (var key in this.sections) {
                if (this.sections.hasOwnProperty(key)) {
                    const section = this.sections[key];

                    let innerListCounter = 0,
                        listType = section.listType,
                        listLimit = section.limitBuy;

                    // list type handled by shopify
                    if (listType === 'mini__size') {
                        listType = 'minisize';
                    } else if (listType === 'free__gift') {
                        listType = 'sample';
                    }
                    
                    // generate 2 arrays of items in cart based on section
                    if (!sectPop.hasOwnProperty(section)) {
                        sectPop[section] = [];
                    }
                    
                    self.SHOPIFY_CART.items.forEach(function (item) {
                        if (item.product_type === listType) {
                            dataPop.push(item.variant_id);
                            sectPop[section].push(item.variant_id);

                            // increment inner list counter
                            innerListCounter++;
                            // increment global counter
                            counter++;
                        }
                    });

                    // check if section has more product than limit
                    if (innerListCounter > listLimit) {
                        errors[section] = {
                            error: true,
                            items: sectPop[section]
                        };
                    }

                    index++;
                }
            }

            // check for general error in both of the section 
            if (counter >= maxCounter) {
                // remove all items from all sections
                this.removeUpsellFromCart(dataPop);
                this.destroy(false);
                
                return false;
            }

            // check for error in single section
            for (key in errors) {
                if (errors.hasOwnProperty(key)) {
                    const element = errors[key];

                    if (element.error) {
                        // remove all items from this section
                        this.removeUpsellFromCart(element.items);
                        dataPop = dataPop.filter(function (el) {
                            return element.items.indexOf(el) < 0;
                        });
                        this.destroy(key);
                    }
                }
            }

            this.cartItems = dataPop;
            this.initPostData();
        }

        return false;
    },

    initPostData: function () {
        this.checkActiveData();
        this.bindAddToCart();
        this.show();
    },

    checkActiveData: function () {
        const   sections    = this.sections,
                cartItems   = this.cartItems;
        
        for (var index in sections) {
            if (sections.hasOwnProperty(index)) {
                const element = sections[index];

                if (element.hasOwnProperty('products')) {
                    let products = element.products;

                    products.forEach(function (product) {
                        if (cartItems.indexOf(product) > -1 && 
                            $("#product-" + product + ".product__upsell__item").length > 0) 
                        {
                            $("#product-" + product + ".product__upsell__item").addClass("active");
                            if (sections[index].hasOwnProperty('counterAddedToCart')) {
                                sections[index]['counterAddedToCart']++;
                            } else {
                                sections[index]['counterAddedToCart'] = 1;
                            }
                        }
                    });

                    if (!sections[index].hasOwnProperty('counterAddedToCart')) {
                        sections[index]['counterAddedToCart'] = 0;
                    }
                }              
            }
        }

        this.sections = sections;
    },

    getCartData: function (callback) {
        const self = this;

        $.getJSON('/cart', function (data) {
            self.SHOPIFY_CART = data;
            callback();
        });
    },

    updateCartTotals: function () {
        const self = this;

        $.get('/cart', function (data) {
            if ($(data).find(self.cartTotals).length > 0) {
                const htmlToReplace = $(data).find(self.cartTotals)[0].outerHTML;
                $(self.cartTotals).replaceWith(htmlToReplace);
            } else {
                window.location.reload();
            }
        });
    },

    bindAddToCart: function () {
        const self = this;

        this.event.bindableWrappers.forEach(function (element) {
            if ($(element).length > 0) {
                $(element).on(self.event.type,  self.event.bindableElement, function(event) {
                    event.preventDefault();

                    const   parentId    = $(element).attr("id"),
                            added       = $(this).hasClass("active"),
                            section     = self.sections[parentId],
                            $item       = $(this),
                            productName = $(this).find(".title").text(),
                            variantId   = $item.data('variant');
                    
                    if (!added) {
                        if (section.counterAddedToCart < section.limitBuy) {
                            $item.addClass("active");
                            // popolate local cart item array
                            self.cartItems.push(variantId);
                            // update shopify via api
                            self.addUpsellToCart(productName, variantId);
                            // increment section counter
                            section.counterAddedToCart++;
                            return;
                        }
                        self.swalMessages.errorItem();
                        return;
                    } else {
                        $item.removeClass("active");
                        // remove cart item from local array
                        self.cartItems.splice(self.cartItems.indexOf(variantId), 1);
                        // update shopify via api
                        self.removeUpsellFromCart(productName, variantId);
                        // increment section counter
                        section.counterAddedToCart--;
                        return;
                    }
                });
            }
        });
    },

    show: function () {
        this.event.bindableWrappers.forEach(function (element) {
            $(element).removeClass('hide');
        });
    },

    destroy: function (elementToRemove) {
        if (elementToRemove === false) {
            this.event.bindableWrappers.forEach(function (element) {
                $(element).remove();
            });
        } else {
            $("#" + elementToRemove).remove();
        }
    },

    /**
     * 
     * @param {string} productName 
     * @param {number} inputData 
     */
    addUpsellToCart: function (productName, inputData) {
        if (inputData) {
            const self = this;

            $.post('/cart/add.js', {
                quantity: 1,
                id: inputData
            }).always(function() {
                self.updateCartTotals();
                self.swalMessages.addItem(productName);
            });
        }
    },


    /**
     * 
     * @param {string} productName 
     * @param {number || array} inputData 
     */
    removeUpsellFromCart: function (productName, inputData) {
        if (typeof inputData === 'number') {
            if (inputData) {
            const self = this;
                var elementToRemove = {};
                elementToRemove[inputData] = 0;

                $.post('/cart/update.js', {
                    updates: elementToRemove
                }).always(function() {
                    self.updateCartTotals();
                    self.swalMessages.removeItem(productName, false);
                });
            }
        } else if (typeof inputData === 'object') {
            const self = this;
            var elementsToRemove = {};

            inputData.forEach(function (variant) {
                elementsToRemove[variant] = 0;     
            });

            $.post('/cart/update.js', {
                updates: elementsToRemove
            }).always(function() {
                self.updateCartTotals();
                self.swalMessages.removeItem(productName, true);
            });
        }
    }
};
